import { Button, Dialog, Divider, Typography } from "@material-ui/core";
import EmojiFlagsIcon from "@material-ui/icons/EmojiFlags";
import Footer from "~/components/common/footerContainer/FooterContainer";
import checkoutServices from "~/services/checkoutServices";
import bookingTransactionAction from "~/store/actions/bookingTransactionAction";
import businessAction from "~/store/actions/businessAction";
import contractAction from "~/store/actions/contractAction";
import { DialogBuilder } from "~/utils/DialogProvider";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";

import SpinnerLoading from "../common/spinnerLoading/SpinnerLoading";
import TitleContainer from "../common/titleContainer/TitleContainer";
import useStyles from "./styles";

const Notifications = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { id, bookingTransactionId } = useParams();
	const { i18n, t } = useTranslation();

	const { user } = useSelector((store) => store.auth);
	const { notifications } = useSelector((store) => store.business);
	const { business } = useSelector((store) => store.business);
	const { bookingTransaction } = useSelector((store) => store.bookingTransaction);
	
	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const language = storageLanguage ?? business?.language;

	const [openPayment, setOpenPayment] = useState(true);

	const [newsCount, setNewsCount] = useState(0);
	const [lastReminderCheckDate, setLastReminderCheckDate] = useState(new Date(0));

	const [selectedReminder, setSelectedReminder] = useState(null);

	const [selectedBooking, setSelectedBooking] = useState(null);

	const [message, setMessage] = useState("");

	const [openMessage, setOpenMessage] = useState(false);

	const [loading, setLoading] = useState(true);

	var token = user?.accessToken;

	const dialog = useContext(DialogBuilder);

	useEffect(() => {
		if (props?.location?.state?.paymentSuccess) {
			dialog
				.withTitle(t("Payment made"))
				.withMessage(t("Your subsequent payment was made successfully!"))
				.withAction(() => props.history.replace("/notificacoes/" + business?.id))
				.show();
		}
	}, []);

	useEffect(() => {
		if (business) {
			if (language === "portuguese") {
				i18n.changeLanguage("pt-BR");
			} else if (language === "spanish") {
				i18n.changeLanguage("es-ES");
			} else {
				i18n.changeLanguage("en-US");
			}
		}
	}, [business, i18n]);

	useEffect(() => {
		if (user !== null && id) {
			dispatch(businessAction.getBusiness(id, token));
		}
	}, [dispatch, id, user, token]);

	useEffect(() => {
		setLoading(false);
		if (user && business && (user.isAnonymous || !user.uid)) {
			localStorage.setItem("@prit-web/coupon", bookingTransactionId || true);
			localStorage.setItem("goBackRoute", JSON.stringify("/notificacoes/" + business.id));
			props.history.push(`/business/link/${business.id}`, {
				goBackRoute: "/notificacoes/" + business.id,
				goBackRouteProps: props.location.state,
			});
		}
	}, [bookingTransactionId, business, props.history, props.location.state, user]);

	useEffect(() => {
		var token = user?.accessToken;
		if (token) {
			dispatch(businessAction.getBusinessNotifications(1, token));
		}
	}, [dispatch, user]);

	const footer = () => {
		return <Footer section={"notificações"} />;
	};

	const elapsedTime = (date) => {
		let time = Date.now();

		time -= new Date(date);

		if (time < 3600000) {
			return Math.floor(time / 60000) + t("minuto(s) atrás");
		}

		if (time >= 3600000 && time < 3600000 * 24) {
			return Math.floor(time / 3600000) + t("hora(s) atrás");
		}

		return Math.floor(time / (3600000 * 24)) + t("dia(s) atrás");
	};

	useEffect(() => {
		let lastCheck = localStorage.getItem("@prit-web/lastReminderCheck");
		if (lastCheck !== null) {
			setLastReminderCheckDate(new Date(lastCheck));
			let count = 0;
			notifications.forEach((element) => {
				if (lastReminderCheckDate < new Date(element.createdAt)) {
					count++;
				}
			});
			setNewsCount(count);
		}
	}, [lastReminderCheckDate, notifications]);

	useEffect(() => {
		let count = 0;
		if (notifications) {
			if (bookingTransactionId !== null) {
				if (openPayment) {
					clickLinkPayment();
				}
			}
			notifications.forEach((element) => {
				if (lastReminderCheckDate < new Date(element.createdAt)) {
					count++;
				}
			});
			setNewsCount(count);
		}
	}, [notifications]);

	const handleCheckAllReminders = () => {
		localStorage.setItem("@prit-web/lastReminderCheck", Date.now());
		setLastReminderCheckDate(Date.now());
		setNewsCount(0);
	};

	useEffect(() => {
		setTimeout(() => setLoading(false), 1000);
	}, []);

	useEffect(() => {
		if (
			selectedReminder &&
			selectedReminder?.data?.status !== "active" &&
			selectedReminder?.data?.status !== "reminder"
		) {
			dispatch(contractAction.getContract(selectedReminder?.data?.recipientId, token));
		}
	}, [dispatch, selectedReminder, token]);

	const getSelectedBooking = (reminder) => {
		if (reminder) {
			dispatch(bookingTransactionAction.getBookingTransaction(reminder?.userId, token));
		}
	};

	const clickLinkPayment = () => {
		setOpenPayment(false);
		const array = notifications;
		if (bookingTransaction)
			bookingTransaction.forEach((booking) => {
				booking.bookings.forEach((element) => {
					if (element.bookingTransactionId === bookingTransactionId) {
						for (let index = 0; index < array.length; index++) {
							const elem = array[index];
							if (elem && elem.bookingTransactionId === bookingTransactionId) {
								setSelectedBooking(elem);
								return;
							}
						}
					}
				});
			});
	};

	useEffect(() => {
		if (bookingTransaction) {
			bookingTransaction.forEach((booking) => {
				booking.bookings.forEach((element) => {
					if (element.bookingTransactionId === selectedReminder?.bookingTransactionId) {
						setSelectedBooking(element);
					}
				});
			});
		}
	}, [bookingTransaction, bookingTransactionId, selectedReminder]);

	const styleCateg = (item) => {
		let style = {};
		if (item.bookingTransactionId === bookingTransactionId && item.data.template === "payment") {
			return (style = { WebkitBoxShadow: "14px 4px 74px 10px rgb(54 139 237) " });
		}
		return style;
	};

	useEffect(() => {
		if (selectedBooking) {
			if (selectedReminder?.data?.status === "active") {
				props.history.push(`/reservas/${selectedBooking?.business?.id}`, { autoOpenModal: selectedBooking.id });
			} else if (selectedReminder?.data?.status === "reminder") {
				props.history.push(`/reservas/${selectedBooking?.business?.id}`);
			}
		}
	}, [bookingTransactionId, props.history, selectedBooking, selectedReminder]);

	useEffect(() => {
		if (bookingTransaction && selectedReminder && selectedReminder?.data?.template === "payment") {
			fetchPaymentRequest(selectedReminder);
		}
	}, [bookingTransaction, selectedReminder]);

	const fetchPaymentRequest = async (item) => {
		const meData = JSON.parse(localStorage.getItem("@prit-web/meData"));
		checkoutServices.fetchPaymentRequest(meData.id).then((res) => {
			const pay = res?.data;
			if (pay) {
				const paymentRequestToPay = pay.find((payment) => payment.payment_request_id === item.data.paymentRequestId);
				if (!paymentRequestToPay) {
					setLoading(false);
					setOpenMessage(true);
					setMessage("Pagamento já foi efetuado ou essa solicitação de pagamento foi cancelada pelo estabelecimento.");
				} else {
					checkoutServices
						.fetchPaymentAnticipatedAmountByBookTransaction({
							recipient_id: item?.data?.recipientId,
							payment_request_id: item?.data?.paymentRequestId,
						})
						.then((res) => {
							if (res.data) {
								let formatedServices = [];

								if (bookingTransaction && paymentRequestToPay.booking_transaction_references) {
									paymentRequestToPay.booking_transaction_references.forEach((ref) => {
										const transaction = bookingTransaction.find((t) => t.id === ref.booking_transaction_id);
										if (transaction) {
											transaction.bookings.forEach((booking) => {
												formatedServices.push({
													date: booking?.startTime,
													dateStart: booking?.startTime,
													professional: {
														avatarUrl: booking?.professional?.avatarUrl || null,
														duration: booking?.duration,
														id: booking?.professional?.id,
														name: booking?.professional?.name || 'Profissional',
														price: booking?.price,
														pricingType: booking?.pricingType?.name || booking?.pricingType,
													},
													professional_id: booking?.professional?.id,
													service: {
														serviceDuration: booking?.duration,
														serviceName: booking?.service?.name,
														servicePrice: booking?.price,
													},
													service_id: booking?.service?.id,
												});
											});
										}
									});
								}
								const postPayment = {
									booking_external_id: item?.bookingTransactionId,
									recipient_id: item?.data?.recipientId,
									payment_request_id: item?.data?.paymentRequestId,
									checkoutInformation: res.data,
									amount: (paymentRequestToPay.amount - paymentRequestToPay?.discount) ,
								};
								props.history.push(`/checkout/${business?.id}`, { postPayment, services: formatedServices || [], laterPayment: postPayment ? true : false });
								setLoading(false);
							} else {
								setLoading(false);
								setMessage(
									"Pagamento já foi efetuado ou essa solicitação de pagamento foi cancelada pelo estabelecimento."
								);
								setOpenMessage(true);
							}
						})
						.catch((err) => {
							setLoading(false);
							setOpenMessage(true);
							setMessage(
								"Pagamento já foi efetuado ou essa solicitação de pagamento foi cancelada pelo estabelecimento."
							);
						});
				}
			} else {
				setLoading(false);
				setMessage("Pagamento já foi efetuado ou essa solicitação de pagamento foi cancelada pelo estabelecimento.");
				setOpenMessage(true);
			}
		});
	};

	return (
		<>
			<TitleContainer footer={footer()}>
				<Typography className={classes.you}>{t("You")}</Typography>
				<div className={classes.header}>
					<div className={classes.news}>
						<Typography className={classes.newsLabel}>{t("Novas")}</Typography>
						<Typography className={classes.count}>{newsCount}</Typography>
					</div>
					<Button className={classes.button} onClick={handleCheckAllReminders}>
						{t("Mark everything as read")}
					</Button>
				</div>
				<Divider></Divider>
				{notifications?.length !== 0 && notifications != null
					? notifications.map((item) => (
							<>
								<div
									style={styleCateg(item)}
									className={classes.reminder}
									onClick={() => {
										setLoading(true);
										setSelectedReminder(item);
										getSelectedBooking(item);
									}}>
									<EmojiFlagsIcon className={classes.icon}></EmojiFlagsIcon>
									<div className={classes.info}>
										<Typography className={classes.title}>{item.title}</Typography>
										<Typography className={classes.message}>{item.message}</Typography>
										<Typography className={classes.time}>{elapsedTime(item.createdAt)}</Typography>
									</div>
									{lastReminderCheckDate < new Date(item.createdAt) && (
										<Typography className={classes.notify}>o</Typography>
									)}
								</div>
								<Divider></Divider>
							</>
					  ))
					: !loading && <Typography className={classes.noNotifications}>Você não tem notificações</Typography>}
			</TitleContainer>
			{/* <WhatsAppButton bottom={"80px"} /> */}
			<SpinnerLoading loading={loading} />
			<Dialog
				onClick={() => setOpenMessage(false)}
				open={openMessage}
				PaperProps={{
					style: { borderRadius: 20, maxWidth: 312 },
				}}>
				<Typography className={classes.messageError}>{message}</Typography>
				<Divider></Divider>
				<Button className={classes.messageButton}>OK</Button>
			</Dialog>
			<SpinnerLoading loading={loading} />
		</>
	);
};

export default withRouter(Notifications);
